import { z } from 'zod';
import { DeviceId } from './session.js';
import { AccessPermission, AssignableRole } from './org.js';
/* ------------------------------------------------------------------ */
/* API REST: corpos validados nos dois lados e formas das respostas     */
/* ------------------------------------------------------------------ */
const Email = z.string().trim().toLowerCase().email('E-mail inválido').max(254);
const Password = z.string().min(8, 'A senha precisa ter pelo menos 8 caracteres').max(128);
const PersonName = z.string().trim().min(1, 'Informe o nome').max(80);
const OrganizationName = z.string().trim().min(1, 'Informe o nome da empresa').max(80);
const GroupName = z.string().trim().min(1, 'Informe o nome do grupo').max(80);
const Uuid = z.string().uuid();
/* ---- contas ---- */
export const SignupBody = z.object({ name: PersonName, email: Email, password: Password });
export const LoginBody = z.object({ email: Email, password: z.string().min(1).max(128) });
/** Atualiza nome/e-mail; senha atual obrigatória se mudar e-mail ou senha. */
export const UpdateAccountBody = z
    .object({
    name: PersonName,
    email: Email,
    currentPassword: z.string().min(1).max(128).optional(),
    newPassword: Password.optional(),
})
    .superRefine((body, ctx) => {
    // Comparação de e-mail fica no servidor (precisa do valor atual); aqui só exige senha se trocar a senha.
    if (body.newPassword && !body.currentPassword) {
        ctx.addIssue({
            code: 'custom',
            message: 'Informe a senha atual para alterar a senha',
            path: ['currentPassword'],
        });
    }
});
/* ---- empresa ---- */
export const CreateOrganizationBody = z.object({ name: OrganizationName });
export const UpdateOrganizationBody = z
    .object({
    name: OrganizationName.optional(),
    allowExternalAccess: z.boolean().optional(),
})
    .refine((b) => Object.keys(b).length > 0, 'Nada para alterar');
export const TransferOwnershipBody = z.object({ userId: Uuid });
/* ---- colaboradores ---- */
export const UpdateMemberBody = z.object({ role: AssignableRole });
export const MemberAccessBody = z.object({
    groupIds: z.array(Uuid).max(500),
    deviceIds: z.array(Uuid).max(500),
    permissions: z.array(AccessPermission).max(10),
    allowUnattended: z.boolean(),
});
/* ---- convites ---- */
export const CreateInvitationBody = z.object({ email: Email, role: AssignableRole });
/* ---- grupos e dispositivos ---- */
export const CreateGroupBody = z.object({ name: GroupName });
export const UpdateGroupBody = z.object({ name: GroupName });
export const UpdateDeviceBody = z
    .object({
    name: z.string().trim().min(1).max(64).optional(),
    groupId: Uuid.nullable().optional(),
})
    .refine((b) => Object.keys(b).length > 0, 'Nada para alterar');
export const CreateEnrollmentBody = z.object({ groupId: Uuid.nullable() });
/* ---- histórico pessoal (acesso por ID) ---- */
export const RecordAccessHistoryBody = z.object({ targetId: DeviceId });
//# sourceMappingURL=api.js.map